import { connect } from 'react-redux';
import { withProps, compose } from 'recompose';
import { bool, string, any } from 'prop-types';

import Dropdown from 'components/base/Dropdown/Dropdown';
import { salesTypePropType } from 'maps/sales-types';
import getSalesType from './helpers';

function mapStateToProps(state) {
  return {
    isExternalUser: state.authentication.isExternalUser,
  };
}

function createProps(ownerProps) {
  const items = getSalesType(ownerProps);
  return { items, gtag: 'sales-type-dropdown' };
}

/**
 * A dropdown precomposed with the available sales types for the current user.
 */
const SalesTypeDropdown = compose(
  connect(mapStateToProps),
  withProps(createProps)
)(Dropdown);

SalesTypeDropdown.propTypes = {
  selectedItem: salesTypePropType.isRequired,
  entityType: any,
  isExternalUser: bool.isRequired,
  hasSplitDownloads: bool.isRequired,
  forceNoEquivalents: bool,
  hasMedia: bool,
  tableName: string,
};

SalesTypeDropdown.defaultProps = {
  isExternalUser: false,
  hasSplitDownloads: false,
  forceNoEquivalents: false,
};

export default SalesTypeDropdown;
